import React, { useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import { Slider, SvgIcon, Accordion, AccordionSummary, AccordionDetails, makeStyles, withStyles, Tooltip} from '@material-ui/core';
import { TextInput, SelectInput } from '../../../../Helpers/Inputs';
import NumberFormatDollars from '../../../../Helpers/Formatters/NumberFormatDollars';
import { BasicInfoSummary, CollapsibleBasicInfoSummary } from '../../../../Quoters/Common/SubComponents/BasicInfoSummary';
import ExpandMoreIcon from '../../../../../icons/expand-more.svg';
import NeedsAnalysis from '../../../../../icons/needs-analysis.svg';
import DigitalCoverageAmounts from '../../../../Helpers/Lists/CoverageAmounts/DigitalCoverageAmounts';
import NeedsAnalysisButton from '../SubComponents/NeedsAnalysisButton';
import StyledRadioInput from '../../../../Helpers/Inputs/StyledRadioInput';
import { GetInflationBenefit, GetInterest, PremiumModesList } from '../../SubComponents/SelectOptions';
import GetYearList from '../../../../Helpers/Lists/YearList';
import InfoIcon from '@material-ui/icons/Info';
import './../Steps/Quoter.scss';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    MuiAccordionroot: {
        "&.MuiAccordion-root:before": {
            backgroundColor: "#f7f7f7 ",
            height: '0px'
        },
        "&.MuiPaper-elevation1": {
            boxShadow: 'none'
        },
        boxShadow: 'none'
    },
    accordionDetails: {
        padding: '30px 16px 16px',
        display: 'block'
    },
}));

export default function QuoteCoverageDetails(props) {

    const { formState, fullFormState, isPiAgeIsMetWithAgeLimit, loading, onFieldChange, history, isSurvivorshipPolicyType } = props;

    const classes = useStyles();

    const insuredInfoDetails = fullFormState && fullFormState.pages && fullFormState.pages.insuredBasicInfo;
    const benefitDurationOptionMinYearValue = isSurvivorshipPolicyType ? 4 : 2;
    const [expanded, setExpanded] = useState(true);

    const handleClick = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleChange = (event, newValue) => {
        onFieldChange('coverageAmount', newValue);
    };

    const getBasicSummaryDetails = () => {
        return (
            insuredInfoDetails.insuredInfo.map((insured, index) => {
                return (
                    <div className='mb-3'>
                        <BasicInfoSummary
                            gender={(insured.gender)}
                            state={(insured.state)}
                            birthdate={(insured.birthdate)}
                            tobacco={(insured.tobacco)}
                            MaritalStatus={(insured.maritalStatus)}
                        />
                    </div>)
            })
        )
    }

    return (
        <React.Fragment>
            <Form onSubmit={e => e.preventDefault()}>
                <h2><b>Coverage Details</b></h2>
                <h3><b>Total Premium</b></h3>
                <Form.Group className='mx-5'>
                    <TextInput
                        name="coverageAmount"
                        id="coverageAmount"
                        aria-label="Coverage Amount"
                        value={formState.coverageAmount}
                        onChange={(e) => onFieldChange('coverageAmount', e.target.value)}
                        variant="outlined"
                        InputProps={{
                            inputComponent: NumberFormatDollars,
                            className: 'coverage-input',
                        }}
                        style={{ backgroundColor: '#f2f2f2', borderColor: 'white!important' }}
                    />
                </Form.Group>

                <Form.Group className="ml-3 mr-4">
                    <Slider
                        min={0}
                        max={500000}
                        step={null}
                        value={formState.coverageAmount}
                        onChange={handleChange}
                        className="m-2"
                        marks={DigitalCoverageAmounts(50000, 500000, 15000)}
                        role="slider"
                        aria-valuemin={50000}
                        aria-valuenow={formState.coverageAmount}
                        aria-valuemax={500000}
                        aria-labelledby="coverageAmount"
                    />
                </Form.Group>
                <Accordion expanded={expanded} className="filter-accordion pb-0" onChange={() => handleClick('filter-panel')} classes={{ root: classes.MuiAccordionroot }}>
                    <AccordionSummary aria-controls={`filter-content`} id={`filter-header`} onClick={() => setExpanded(!expanded)} className='p-0 expand'>
                        <SvgIcon component={ExpandMoreIcon} className={expanded ? 'expanded' : ''} />Options
                    </AccordionSummary>
                    <AccordionDetails className='row pb-0'>
                        <Row className="mt-2 mb-2 w-100">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="premiumMode"
                                    id="premiumMode"
                                    value={formState.premiumMode}
                                    onChange={(e) => onFieldChange('premiumMode', e.target.value)}
                                    label="Premium Mode"
                                    hideEmptyOption
                                    selectOptions={PremiumModesList(isSurvivorshipPolicyType)}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-2 mt-2">
                                <Tooltip id="riders-tooltip" title={"Time period when total Premium amount will be paid."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>
                        {!isPiAgeIsMetWithAgeLimit && <div className='errorMessage'>{formState.premiumMode} premium mode issue age range is 30 - 65 years.</div>}
                        <Row className="mt-2 mb-2 w-100">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="benefitDuration"
                                    id="benefitDuration"
                                    value={formState.benefitDuration}
                                    onChange={(e) => onFieldChange('benefitDuration', e.target.value)}
                                    label={isSurvivorshipPolicyType ? "Joint Benefit Duration" : "Benefit Duration"}
                                    hideEmptyOption
                                    selectOptions={GetYearList(benefitDurationOptionMinYearValue, 8, isSurvivorshipPolicyType)}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-2 mt-2">
                                <Tooltip id="riders-tooltip" title={"Elected duration when benefits will be paid."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>

                        <Row className="mt-2 mb-2 w-100">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="infBenefit"
                                    id="infBenefit"
                                    value={formState.infBenefit}
                                    onChange={(e) => onFieldChange('infBenefit', e.target.value)}
                                    label="Inflation Benefit Option"
                                    hideEmptyOption
                                    selectOptions={GetInflationBenefit(isSurvivorshipPolicyType)}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-2 mt-2">
                                <Tooltip id="riders-tooltip" title={"Increase the monthly Premium benefit by the selected percentage on each policy anniversary."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-3 w-100">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="interestRate"
                                    id="interestRate"
                                    value={formState.interestRate}
                                    onChange={(e) => onFieldChange('interestRate', e.target.value)}
                                    label="Assumed Interest Rate"
                                    hideEmptyOption
                                    selectOptions={GetInterest}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-2 mt-2">
                                <Tooltip id="riders-tooltip" title={"The Assumed Market Interest Rate is the selected rate of return that policy investments are being projected to earn prior to any charges or fees being assessed."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>


                        <Form.Group className='w-100'>
                            <StyledRadioInput
                                name="returnPremium"
                                id="returnPremium"
                                label="Return of premium"
                                value={formState.returnPremium}
                                options={[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]}
                                onChange={(e) => onFieldChange('returnPremium', e)}
                                errors={props.error}
                                inputRef={props.inputRef}
                            />
                        </Form.Group>

                    </AccordionDetails>
                </Accordion>

                {insuredInfoDetails &&
                    <React.Fragment>
                        <CollapsibleBasicInfoSummary
                            component={getBasicSummaryDetails()}
                            editLinkOnClick={() => history.push('/Products/ABLTC/basic-info')}
                            showMultipleInsuredInfo={true}
                        />
                    </React.Fragment>
                }

                <div id="sr-message" role="alert" aria-live="assertive" className="sr-only">
                    <h2>{loading ? "loading.." : "product list updated"}</h2>
                </div>
            </Form>
            <h4 className='mt-4'><b>Insurance Tools</b></h4>
            <NeedsAnalysisButton history={history} component={NeedsAnalysis} type="quote-screen" title='How much I need' />
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/SubComponents/QuoteCoverageDetails.js